import { Button } from "react-bootstrap"

function ExportButton({onExport, label}) {
  return (
    <Button onClick={e => onExport(e.target.value)}>{label}</Button>
  )
}

export default ExportButton